import React, { FC } from 'react';
import styled from 'styled-components';
import Text from 'crehana-ui/Text';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';
import Dialog from 'crehana-ui/Dialog';

import mixpanel from 'Jsx/Utils/mixpanelTracking';

const MembershipBenefits = styled.div`
  top: -32px;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 314px;
  }
`;

interface BenefitsDialogProps {
  setBenefitsCardVisible(visibility: boolean): void;
  isBenefitsCardVisible: boolean;
  membershipUrlCheckout: string;
  benefits: Array<{ id: number; Icon: React.ReactElement; text: string }>;
}

const Benefits: FC<BenefitsDialogProps> = ({
  setBenefitsCardVisible,
  isBenefitsCardVisible,
  membershipUrlCheckout,
  benefits,
}) => {
  return (
    <Dialog
      open={isBenefitsCardVisible}
      onDismiss={() => {
        setBenefitsCardVisible(false);
      }}
      size="s"
    >
      <div
        className="bg-base-main relative flex justify-center items-center"
        style={{ height: 420 }}
      >
        <MembershipBenefits
          className="absolute block px-24 py-32 bg-base-main mt-16 sm:mt-0"
          style={{ top: 'auto' }}
        >
          <Text
            className="mb-16"
            type="subtitle3"
            color="white"
            as="p"
            responsive="sm"
          >
            Beneficios exclusivos de tu Membresía Premium
          </Text>
          <ul>
            {benefits.map(benefit => (
              <li key={benefit.id} className="flex items-center mb-12">
                {benefit.Icon}
                <Text className="ml-16" type="body4" color="white" as="p">
                  {benefit.text}
                </Text>
              </li>
            ))}
          </ul>
          <PrimaryButton
            className="mt-24"
            full
            size="l"
            onClick={() => {
              mixpanel.track(mixpanel.EVENTS.BUY, {
                productType: 'membership',
                origin: 'Course detail - a/b test floating card',
              });
              location.href = membershipUrlCheckout;
            }}
            label="Vuélvete Premium"
          />
        </MembershipBenefits>
      </div>
    </Dialog>
  );
};

export default Benefits;
